/* Matcha Sunday wholesale "how often" chooser (snippets/wholesale-subscribe.liquid).
   Subscribe & save (preselected) or One-time order; the frequency dropdown sits inside the subscribe card. Keeps the hidden selling_plan field in
   sync with the chosen option and frequency, and re-prices when the variant (case size)
   changes. Prices come pre-formatted from Liquid in data-prices, keyed by variant id. */
(function () {
  function findForm(root) {
    var id = root.getAttribute('data-form');
    var byId = id ? document.getElementById(id) : null;
    if (byId && byId.tagName === 'FORM') return byId;
    var info = root.closest('.product-info') || document;
    return info.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function boot(root) {
    if (root.__whSub) return;
    root.__whSub = true;

    var prices = {};
    try { prices = JSON.parse(root.getAttribute('data-prices') || '{}'); } catch (err) { prices = {}; }

    var planInput = root.querySelector('[data-wholesale-plan]');
    var select = root.querySelector('[data-wholesale-freq]');
    var freqWrap = root.querySelector('[data-wholesale-freq-wrap]');
    var options = [].slice.call(root.querySelectorAll('[data-wholesale-mode]'));
    var variantId = root.getAttribute('data-variant') || Object.keys(prices)[0];
    if (!planInput || !select || !freqWrap) return;

    /* form.id would return the form's own <input name="id"> (named access shadows the
       attribute), so always read the id attribute itself. */
    var form = findForm(root);
    if (form) {
      if (!form.getAttribute('id')) form.setAttribute('id', 'wholesale-product-form-' + Date.now());
      planInput.setAttribute('form', form.getAttribute('id'));
    }

    function mode() { return root.getAttribute('data-mode') === 'onetime' ? 'onetime' : 'subscribe'; }

    function setText(selector, text) {
      root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
    }

    var subscribeCard = root.querySelector('[data-wholesale-mode="subscribe"]');
    var savingEl = root.querySelector('[data-wholesale-saving]');
    var wasEls = root.querySelectorAll('[data-wholesale-was]');
    var adjust = root.getAttribute('data-adjust') || 'percentage';
    var pct = root.getAttribute('data-pct') || '';

    function money(cents) {
      var whole = cents % 100 === 0;
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    }

    /* Only offer the plans this variant actually carries. Returns the plan id now selected,
       or '' when the variant has no plan at all. */
    function syncPlanOptions(v) {
      var firstOk = '';
      var selectedOk = false;
      [].slice.call(select.options).forEach(function (opt) {
        var ok = !!(v && v.plans && v.plans[opt.value]);
        opt.hidden = !ok;
        opt.disabled = !ok;
        if (ok && !firstOk) firstOk = opt.value;
        if (ok && opt.value === select.value) selectedOk = true;
      });
      if (!selectedOk) select.value = firstOk;
      return firstOk ? select.value : '';
    }

    function update() {
      var v = prices[variantId] || prices[Object.keys(prices)[0]];
      var planId = syncPlanOptions(v);
      var canSubscribe = !!planId;
      if (subscribeCard) subscribeCard.hidden = !canSubscribe;
      if (!canSubscribe && mode() === 'subscribe') root.setAttribute('data-mode', 'onetime');
      var subscribe = mode() === 'subscribe';
      var plan = canSubscribe && v ? v.plans[planId] : null;
      var saving = plan ? v.once - plan.c : 0;
      if (v) {
        setText('[data-wholesale-once]', v.once_f);
        setText('[data-wholesale-was]', v.once_f);
        setText('[data-wholesale-sub]', plan ? plan.f : v.once_f);
      }
      /* Never claim a saving that is not there. */
      wasEls.forEach(function (el) { el.hidden = saving <= 0; });
      if (savingEl) {
        if (saving <= 0) savingEl.textContent = '';
        else if (adjust === 'percentage') savingEl.textContent = pct + '% off every delivery';
        else savingEl.textContent = 'Save ' + money(saving) + ' every delivery';
      }
      freqWrap.hidden = !subscribe;
      planInput.disabled = !subscribe;
      planInput.value = subscribe ? planId : '';
      options.forEach(function (btn) {
        var on = btn.getAttribute('data-wholesale-mode') === mode();
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var label = subscribe ? select.options[select.selectedIndex].text : 'Once';
      setText('[data-wholesale-mode-label]', label);
      /* Tell the rest of the page what the customer is really paying for this variant. */
      var target = form || document;
      target.dispatchEvent(new CustomEvent('wholesale:change', {
        bubbles: true,
        detail: { variantId: variantId, mode: mode(), planId: subscribe ? planId : '', cents: subscribe && plan ? plan.c : (v ? v.once : null) }
      }));
    }

    options.forEach(function (card) {
      function choose() { root.setAttribute('data-mode', card.getAttribute('data-wholesale-mode')); update(); }
      card.addEventListener('click', function (event) {
        if (event.target.closest('select, label')) return; /* the dropdown inside the card keeps its own behaviour */
        choose();
      });
      card.addEventListener('keydown', function (event) {
        if (event.target !== card) return;
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(); }
      });
    });
    select.addEventListener('change', update);

    /* The theme's variant picker fires variant:change on the product form (it bubbles). */
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && prices[String(variant.id)]) {
        variantId = String(variant.id);
        update();
      }
    });

    update();
  }

  function init() { document.querySelectorAll('wholesale-subscribe').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
